//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';

import ConnectedBulkAddToGalleries from '@galleries/components/modals/bulk-add-to-galleries/BulkAddToGalleriesModal';
import { getAddToGalleriesInitialSelectedItems } from '@galleries/selectors/getAddToGalleriesInitialSelectedItems';
import Cuid from '@models/Cuid';
import makeAngReactController from '@react-bridge/angular-react-widget';
import { getClientId } from '@redux/selectors/getClientId';
import { useMultipleMediaMetadataQuery } from '@uia/details/hooks/useMediaMetadataQuery';

export const BulkAddToGalleriesModalWrapped = () => {
  const clientId = useSelector(getClientId);

  const cuids = useSelector(getAddToGalleriesInitialSelectedItems).map((item) =>
    Cuid.fromPartial(item.cuid, clientId),
  );

  const {
    data: metadataMap,
    isError: metadataError,
    isPending: metadataLoading,
  } = useMultipleMediaMetadataQuery(cuids);

  return (
    <ConnectedBulkAddToGalleries
      isMediaMetadataLoading={metadataLoading}
      isMediaMetadataLoadingError={metadataError}
      mediaMetadata={metadataMap}
    />
  );
};

angular.module('curalate').component('bulkAddToGalleriesModalWrapped', {
  controller: makeAngReactController(<BulkAddToGalleriesModalWrapped />),
});
